import React, { useState, useEffect } from 'react';
import './Wishes5.css';
import Space from './Space';

const Wishes5 = ({ wishes }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsVisible(false); // Start fading out

            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex === wishes.length - 1 ? 0 : prevIndex + 1));
                setIsVisible(true); // Fade in the next sentence
            }, 1000);
        }, 5000);

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [currentIndex, wishes.length]);

    if (wishes.length === 0) return null;

    return (
        <div className="section wishes-section">
            <h1 className="cDark w100">WISHES FROM THE GUESTS</h1>
            <div className={`wishes-container fade-container ${isVisible ? 'fade-in' : 'fade-out'}`}>
                <p className={`cDark w500 italic left`}>{wishes[currentIndex].wish}</p>
                <Space s={16} />
                <p className="cDark w300 right">-{wishes[currentIndex].from}</p>
            </div>
        </div>
    );
};

export default Wishes5;
